import React, { useEffect, useState } from 'react';

// Components
import NoItems from '../util/noitems/NoItems';
import Pagination from '../util/pagination/Pagination';
import Loading from '../util/loading/Loading';
import { ModalSucursal } from './ModalSucursal';
import Field from '../util/field/Field';
import Select from 'react-select';

// Utils
import {toast} from 'react-toastify';

// Services
import SucursalAPI from '../../services/Sucursales';

// Constants
const ESTATUS = [
    {
        id: 1,
        value: false,
        label: 'INACTIVO',
    },
    {
        id: 2,
        value: true,
        label: 'ACTIVO',
    },
]

/**
 * Componente para modulo de Sucursales.
 * @returns Component
 */
export const CatalogoSucursales = () => {
    const [ state, setState ] = useState({
        pages: [],
        isLoading: false,
        listSucursales: [],
        sucursalSelected: {},
        modalVisible: false,
        filters: {
            nombre: '',
            estatus: null
        }
    });

    useEffect(() => {
        setState({ ...state, isLoading: true });
        let sucursales = [];
        let allPages = [];

        SucursalAPI.getAllSucursales()
            .then(res => {
                allPages = res.data;
                sucursales = res.data;
            })
            .catch(err => {
                toast.error('Ocurrio un error al consulatar las sucursales.');
                console.error(err);
            })
            .finally(() => setState({
                ...state,
                isLoading: false,
                pages: allPages,
                listSucursales: sucursales,
            }));
    }, []);

    /**
     * Actualiza la lista con los datos nuevos.
     * @param {Object} data - Datos a actualizar
     */
    const handleUpdateList = data => {
        setState({ ...state, isLoading: true });

        const oldList = [...state.listSucursales];
        let startIndex = null;
        oldList.find((suc, ixd) => {
            if ( suc.idSucursal === data.idSucursal )
                startIndex = ixd;
        });
        oldList.splice(startIndex, 1, data);

        setState({
            ...state,
            listSucursales: [...oldList],
            isLoading: false,
            modalVisible: false,
            sucursalSelected: {}
        });

        toast.success('Sucursal editada');
    }

    /**
     * Limpia los filtros y trae los valores iniciales para la tabla.
     */
     const handleCleanFilters = () => {
        setState({...state, isLoading: true});
        let sucursales = [];
        SucursalAPI.getAllSucursales({})
            .then(res => sucursales = res.data)
            .catch(() => toast.error("Ocurrio un problema al filtrar las sucursales."))
            .finally(() => setState({
                ...state,
                filters: {
                    nombre: '',
                    estatus: null
                },
                isLoading: false,
                listSucursales: sucursales,
                pages: sucursales
            }));
    }

    /**
     * Filtrado de las sucursales.
     */
    const handleFilterSucursales = () => {
        setState({...state, isLoading: true});
        let sucursales = [];
        let filters = {};

        if ( state.filters.estatus )
            filters.estatus = state.filters.estatus.value
        if ( state.filters.nombre )
            filters.nombre = state.filters.nombre.normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim();
        else if ( state.filters.nombre === "" )
            delete filters.nombre

        SucursalAPI.getAllSucursales({ ...filters })
            .then(res => sucursales = res.data)
            .catch(() => toast.error("Ocurrio un problema al filtrar las Sucursales."))
            .finally(() => setState({
                ...state,
                isLoading: false,
                listSucursales: sucursales,
                pages: sucursales
            }));
    }


    return (
        <div>
            {
                state.isLoading &&
                <Loading
                    isFullscreen={true}
                    isLoading={state.isLoading}
                    width='100px'
                    height='100px'
                />
            }
            <h1 className='title is-2'>Catálogo de Sucursales</h1>
            {/* <br />
            <div className='row'>
                <div className='columns'>
                    <div className='column is-12 is-flex' style={{justifyContent: 'flex-end'}}>
                        <button
                            className='button is-success'
                            onClick={() => setState({...state, modalVisible: true})}
                        >
                            Agregar Sucursal
                        </button>
                    </div>
                </div>
            </div> */}
            <br />
            {/* Filtros */}
            <div className='card'>
                <div className='card-content'>
                    <div className="row">
                        <div className='columns is-multiline'>
                            <div className='column is-3'>
                                <label className='label'>Nombre</label>
                                <div className='control'>
                                    <input
                                        type='text'
                                        className='input'
                                        maxLength={50}
                                        value={state.filters.nombre}
                                        placeholder='Ingrese el nombre'
                                        onChange={({target}) => setState({
                                            ...state,
                                            filters: {
                                                ...state.filters,
                                                nombre: target.value
                                            }
                                        })}
                                    />
                                </div>
                            </div>
                            <div className='column is-3'>
                                {/* <label className='label'>Estatus</label>
                                <div className='control'>
                                    <Select
                                        placeholder={"Seleccionar..."}
                                        name={"selectedOption"}
                                        value={state.filters.estatus}
                                        noOptionsMessage={() => "No hay opciones"}
                                        onChange={item => setState({
                                            ...state,
                                            filters: {
                                                ...state.filters,
                                                estatus: item
                                            }
                                        })}
                                        options={ESTATUS}
                                    />
                                </div> */}
                            </div>
                            <div className='column is-3'>
                            </div>
                            <div className='column is-3'>
                                <button
                                    className='button is-success'
                                    onClick={handleFilterSucursales}
                                >
                                    Filtrar
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="columns">
                            <div className="column is-3"></div>
                            <div className="column is-3"></div>
                            <div className="column is-3"></div>
                            <div className="column is-3">
                                <button
                                    className="button"
                                    onClick={handleCleanFilters}
                                >
                                    Limpiar filtros
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br />
            {/* Tabla de resultados */}
            <div className='card'>
                <div className='card-content'>
                    {
                        state.listSucursales.length !== 0 ?
                        <table className='table is-fullwidth'>
                            <thead>
                                <tr>
                                    <th>Nombre</th>
                                    <th>Punto de Venta</th>
                                    <th>Estatus</th>
                                    <th>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    state.pages.map(suc =>
                                        <tr key={suc.idSucursal}>
                                            <td>{suc.Nombre}</td>
                                            <td>{suc.NombreNuevo}</td>
                                            <td>
                                                <Field>
                                                    <input
                                                        type="checkbox"
                                                        name='isActive'
                                                        className='switch'
                                                        checked={suc.Estatus}
                                                        disabled
                                                    />
                                                    <label />
                                                </Field>
                                            </td>
                                            <td>
                                                <button
                                                    className='button is-warning'
                                                    onClick={() => setState({ ...state, modalVisible: true, sucursalSelected: suc })}
                                                >
                                                    Editar
                                                </button>
                                            </td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                        : <NoItems itemName='Sucursales' />
                    }
                    <Pagination
                        items={ state.listSucursales }
                        pageSize={10}
                        onChangePage={suc => setState({ ...state, pages: suc })}
                    />
                </div>
            </div>
            { state.modalVisible &&
                <ModalSucursal
                    onUpdate={ data => handleUpdateList( data ) }
                    sucursal={state.sucursalSelected}
                    onClose={ () => setState({...state, modalVisible: false, sucursalSelected: {}}) }
                />
            }
        </div>
    )
}